/* eslint-disable no-unused-vars */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customers: {},
};

export const customersList = createSlice({
  name: "cusomers",
  initialState,
  reducers: {
    customerData: (state, action) => {
      state.customers = action.payload;
    },
  },
});

const { actions, reducer } = customersList;
export const { customerData } = actions;

// export const fetchCustomers = (data) => async (dispatch) => {
//   const { response } = await CustomerService.getCustomers(
//     handlingUrlParams({
//       PageNumber: 1,
//       PageSize: 10000000,
//     })
//   );
//   if (response) {
//     let customersData = response;
//     dispatch(customerData({ data: customersData }));
//     console.log("redux result", response);
//   }
// };

export default reducer;
